import React, { useState } from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import {
  FlexRowCenterVertical,
  FlexBetween,
  FlexCol,
  DsiMobileNavigationItem as MobileNavItem,
  DsiItemType as ItemType,
  TextP,
  DsiMobileNavSubItem as MobileNavSubItem,
  DsiSvgIcon as SvgIcon,
  DsiIconType,
} from 'eshop-defaults';
import API, { ThenArg } from '../../services/API';
import { getImagePath } from '../../utilities/product';
import { IconType } from 'eshop-defaults/lib/components/Dsi/General/SvgIcon';
import { __, __r } from 'react-i18n';
import { prop } from '../../utilities';
import { resolveCategoryUrl } from 'eshop-defaults/lib/utilities/selectors';
import { getMyAccountMenuItems } from '../../containers/MyAccount/myAccountSlice';

export interface Props {
  domainId: any;
  closeMenu: () => void;
}

function MobileUserNavigation({ domainId, closeMenu }: Props) {
  const items = getMyAccountMenuItems(null, domainId);
  return <Wrapper>{renderContentItems(items, closeMenu)}</Wrapper>;
}

const renderContentItems = (items: any, closeMenu: () => void) => {
  return (
    <MenuItemsWrapper>
      {items.map(item => {
        return (
          <MobileNavItem
            url={item.url}
            type={ItemType.PRIMARY}
            onClick={closeMenu}
            title={
              <FlexBetween>
                <span>{item.name}</span>
              </FlexBetween>
            }
          />
        );
      })}
    </MenuItemsWrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
`;

const IconTitleWrapper = styled(FlexRowCenterVertical)`
  width: 100%;
  /* justify-content: flex-start; */
  margin-bottom: ${rem(6)};
  padding: 0 ${rem(16)};

  padding-left: 0;
  padding-right: 0;
`;

const IconWrapper = styled.div`
  padding: ${rem(16)};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  display: inline-block;

  svg {
    vertical-align: baseline;
  }
`;

const HigherLevelIconWrapper = styled.div`
  padding: ${rem(16)};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  display: inline-block;

  svg {
    vertical-align: baseline;
  }
`;

const MenuItemsWrapper = styled(FlexCol)``;

const Title = styled(TextP)<{ isFirstLevel }>`
  font-weight: 500;
  font-size: ${rem(14)};
  line-height: ${rem(20)};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-left: ${({ isFirstLevel }) => (isFirstLevel ? rem(16) : rem(-4))};
  display: inline-block;
  flex: 1 1 auto;
`;

export { MobileUserNavigation };
